var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.767 6.159a.599.599 0 0 0-.86 0L5.138 9.004A.6.6 0 0 0 6 9.84l1.737-1.786v8.957a.6.6 0 1 0 1.2 0V8.053l1.739 1.788a.6.6 0 0 0 .86-.836L8.768 6.158v.001ZM16.811 17.426a.6.6 0 0 1-.852.003l-2.846-2.846a.6.6 0 0 1 .849-.848l1.822 1.822V6.569a.6.6 0 1 1 1.2 0v8.988l1.821-1.822a.6.6 0 1 1 .849.848l-2.843 2.843Z",
    clipRule: "evenodd"
  })));
};
export default SvgSort;